import React from 'react';

type ContentBodyProps = {
  body?: string;
  className?: string;
};

const ContentBody = ({ body, className }: ContentBodyProps) => {
  let contentBody = body;
  if (!contentBody || contentBody.length === 0) {
    return (null);
  }

  contentBody = contentBody.replace(/<(span|div).+?>/g, '').replace(/<\/(span|div)>/g, '').trim(); // Strip out WP rubbish

  return (
    <div
      dangerouslySetInnerHTML={{ __html: contentBody }}
      className={className}
    />
  );
};

export default ContentBody;
